import React, { Component } from "react";
import { useParams } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import "./App.css";
import "./form/FormInput.css";
import QRdiv from './qrcode/QRdiv'
import ChangeStyleQR from './qrcode/ChangeStyleQR'
import SketchColor from "./form/SketchColor.js";
import SEO from './seo/SEO'
import {Navbar, Nav} from 'react-bootstrap';
import ImageUploader from 'react-images-upload';
import LeftSidebar from './components/LeftSidebar'
import DateTimePicker from './form/DateTimePicker'
import YandexMapPicker from './form/YandexMapPicker'

/*eslint-disable no-eval */

/** Format datetime-local value to server format "YYYYMMDDTHHmmssZ" (UTC) */
function formatDateTimeForServer(dateTimeLocalStr) {
  if (!dateTimeLocalStr) return dateTimeLocalStr;
  const d = new Date(dateTimeLocalStr);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  const h = String(d.getUTCHours()).padStart(2, '0');
  const min = String(d.getUTCMinutes()).padStart(2, '0');
  const s = String(d.getUTCSeconds()).padStart(2, '0');
  return `${y}${m}${day}T${h}${min}${s}Z`;
}

// Last part of URL (/qr/create/<formName>/) maps to formId; used to download form and text content
const FORM_NAME_TO_ID = [
  { name: 'yamoney', id: 10 }, { name: 'sbp', id: 20 }, { name: 'wifi', id: 30 },
  { name: 'phone', id: 40 }, { name: 'text', id: 50 }, { name: 'url', id: 60 },
  { name: 'perevod', id: 70 }, { name: 'telegram', id: 90 },   { name: 'calendar-event', id: 100 },
  { name: 'vcard', id: 110 },
  { name: 'geo', id: 120 },
  { name: 'oplata-yur', id: 130 }
];

const OPLATA_FORM_ID = 130;
const OPLATA_CABINET_SIGNUP_URL = 'https://sbqr.ru/page/payment_QR.html';
const OPLATA_CABINET_RENEW_BASE = 'https://sbqr.ru/simpleQR/ticketQR.php?inn=';
const PAYEE_FIELD_NAMES = ['PayeeINN', 'KPP', 'Name', 'BIC', 'CorrespAcc', 'BankName', 'PersonalAcc'];
const EXPIRED_VISIBLE_FIELDS = [...PAYEE_FIELD_NAMES, 'lastName', 'payerAddress', 'Purpose', 'summaRub', 'summaKop'];
const BUDGET_FIELD_NAMES = ['budget', 'CBC', 'OKTMO', 'PayerINN', 'Regnum'];
const BUDGET_PROFILE_FIELD_NAMES = ['CBC', 'OKTMO'];
const PAYER_SUM_NAMES = ['lastName', 'payerAddress', 'Purpose', 'summaRub', 'summaKop'];
const OPLATA_SUM_FIELD_NAMES = ['summaRub', 'summaKop'];
const SEO_META_OVERRIDES = {
  yamoney: {
    title: 'Создать QR-код для оплаты ЮMoney',
    description: 'Сформируйте QR-код для оплаты через ЮMoney: укажите данные платежа, настройте внешний вид и скачайте готовый код.'
  },
  wifi: {
    title: 'Создать QR-код для Wi-Fi сети онлайн',
    description: 'Сгенерируйте QR-код для подключения к Wi-Fi: SSID, пароль и тип шифрования. Бесплатно, с логотипом и дизайном.'
  },
  url: {
    title: 'Создать QR-код для ссылки (URL) онлайн',
    description: 'Создайте QR-код для сайта или любой ссылки. Настройте дизайн, добавьте логотип и скачайте готовый QR-код бесплатно.'
  },
  sbp: {
    title: 'Создать QR-код для оплаты через СБП',
    description: 'Сформируйте QR-код для оплаты по СБП: заполните реквизиты и получите готовый платежный QR-код для печати или отправки.'
  },
  phone: {
    title: 'Создать QR-код с номером телефона',
    description: 'Сделайте QR-код с номером телефона для быстрого звонка. Добавьте логотип, настройте стиль и скачайте изображение.'
  },
  text: {
    title: 'Создать QR-код с текстом онлайн',
    description: 'Создайте QR-код с произвольным текстом: сообщение, инструкция или заметка. Настройте дизайн и скачайте результат.'
  },
  perevod: {
    title: 'Создать QR-код для перевода',
    description: 'Сформируйте QR-код для перевода по банковским реквизитам. Заполните данные получателя и получите готовый QR-код.'
  },
  telegram: {
    title: 'Создать QR-код для Telegram',
    description: 'Сгенерируйте QR-код для Telegram: ссылка на профиль, канал или чат. Добавьте логотип и стиль под ваш бренд.'
  },
  'calendar-event': {
    title: 'Создать QR-код для события в календаре',
    description: 'Создайте QR-код для добавления события в календарь: дата, время, место и описание. Удобно для афиш и приглашений.'
  },
  vcard: {
    title: 'Создать QR-код визитки (vCard)',
    description: 'Сделайте QR-код визитки vCard с контактами: имя, телефон, email и компания. Быстрое сохранение контакта в смартфон.'
  },
  geo: {
    title: 'Создать QR-код с геолокацией',
    description: 'Сгенерируйте QR-код с координатами и точкой на карте. Подходит для адресов офисов, пунктов выдачи и мероприятий.'
  },
  'oplata-yur': {
    title: 'Создать QR-код для оплаты юрлицу',
    description: 'Создайте платежный QR-код для юридического лица: реквизиты, назначение платежа и сумма. Подходит для счетов и квитанций.'
  }
};

function sortOplataFormFieldKeys(formData) {
  const keys = Object.keys(formData);
  const sumKeys = [];
  const otherKeys = [];
  keys.forEach((k) => {
    if (OPLATA_SUM_FIELD_NAMES.includes(formData[k].NAME)) {
      sumKeys.push(k);
    } else {
      otherKeys.push(k);
    }
  });
  sumKeys.sort(
    (a, b) =>
      OPLATA_SUM_FIELD_NAMES.indexOf(formData[a].NAME) -
      OPLATA_SUM_FIELD_NAMES.indexOf(formData[b].NAME)
  );
  return [...otherKeys, ...sumKeys];
}

/** Budget sub-fields from profile columns when not already in add_req (same rules as add_req). */
function computeBudgetVisibleNames(profile, addReqFields) {
  const addReqVisible = addReqFields.filter((f) => f.visible).map((f) => f.name);
  const addReqHidden = addReqFields.filter((f) => !f.visible).map((f) => f.name);
  if (!profile.budget && !profile.CBC && !profile.OKTMO) {
    return [];
  }
  return BUDGET_PROFILE_FIELD_NAMES.filter((name) => {
    if (addReqVisible.includes(name) || addReqHidden.includes(name)) {
      return false;
    }
    return !!profile[name];
  });
}

function getKeyIdFromUrl() {
  if (typeof window === 'undefined') return '';
  return new URLSearchParams(window.location.search).get('key_id') || '';
}

function getFormIdByFormName(formName) {
  const item = FORM_NAME_TO_ID.find((e) => e.name === formName);
  return item ? item.id : 90;
}

function getSeoMeta(formName, fallbackTitle, fallbackDescription) {
  const override = SEO_META_OVERRIDES[formName];
  if (!override) {
    return {
      title: fallbackTitle,
      description: fallbackDescription
    };
  }
  return override;
}

class AppComponent extends Component {
  constructor(props) {
    super(props);
    const formName = props.formName;
    const formId = getFormIdByFormName(formName);
	
	
	this.state = {
	  formData: [],
	  initialFormValues: {},
	  idQR: "qr_code_1",
	  valueQR: "https://sbqr.ru",
	  isVisiableQR: false,
	  sizeQR: 100,
	  sizeCustomQR: 500,
	  opacityQR: 100,
	  levelQR: "H",
	  typeQR: "rect",
	  posTypeQR: "rect",
	  posTypeQR2: "dsj",
	  otherColorQR: "#000",
	  posColorQR: "#000",
	  bgColorQR: "#FFFFFF",
	  eyeColorQR: "#000000",
	  displayColorPicker: false,
	  displayPosColorPicker: false,
	  displayBgColorPicker: false,
	  displayEyeColorPicker: false,
	  scaleQR: 70,
	  crossWidthQR: 70,
	  posWidhQR: 90,
	  isMarginQR: true,
	  qrStyleCustom: "squares",
	  logoSizeQR: 20,
	  eyeRadiusQR: 0,
	  logoPaddingQR: 0,
	  gradientType: "none",
	  gradientColor1: "#000000",
	  gradientColor2: "#0000FF",
	  displayGradientColor1Picker: false,
	  displayGradientColor2Picker: false,
      formId: formId,
	  isFill: false,
      title: "Создать QR код с логотипом и дизайном",
	  formName: formName,
	  QRstyle: "QRCustom",
	  icon: null,
	  imgQR: null,
	  paymentMode: 'public',
	  keyId: '',
	  paymentNotice: '',
	  addReqVisibleNames: [],
	  budgetVisibleNames: []
    };
  }
  
     
  
  loadFormContent(formId, formName = this.state.formName) {
    const URL = "https://sbqr.ru/qr/get_form.php?id=" + formId;
    fetch(URL)
      .then(res => res.json())
      .then(json => {
        const initialFormValues = Object.fromEntries(
          Object.keys(json).map((ind) => {
            const name = json[ind].NAME;
            if (Number(formId) === 120 && name === 'geo_map_type') {
              return [name, 'Яндекс.Карты'];
            }
            if (name === 'budget') {
              return [name, false];
            }
            return [name, ''];
          })
        );
        if (Number(formId) === OPLATA_FORM_ID) {
          this.loadOplataProfile(json, initialFormValues);
        } else {
          this.setState({
            formData: json,
            initialFormValues,
            paymentMode: 'public',
            keyId: '',
            paymentNotice: '',
            addReqVisibleNames: [],
            budgetVisibleNames: []
          });
        }
      });

    const URL2 = "https://sbqr.ru/qr/get_text_form.php?id=" + formId;
    fetch(URL2)
      .then(res2 => res2.json())
      .then(result => {
        const row = Object.values(result)[0];
        const title = row.TITLE;
        const intro = row.INTRO;
        const seoMeta = getSeoMeta(formName, title, intro);
        const body = row.BODY;
        const finality = row.FINALITY;
        this.setState({ title: seoMeta.title, intro: seoMeta.description, body, finality });
        document.title = seoMeta.title;
      });
  }

  componentDidMount() {
    this.loadFormContent(this.state.formId, this.state.formName);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.formName !== this.props.formName) {
      const formId = getFormIdByFormName(this.props.formName);
      this.setState({
        formId,
        formName: this.props.formName,
        formData: [],
        initialFormValues: {},
        isFill: false,
        isVisiableQR: false,
        paymentMode: 'public',
        keyId: '',
        paymentNotice: '',
        addReqVisibleNames: [],
        budgetVisibleNames: []
      });
      this.loadFormContent(formId, this.props.formName);
    }
  }

  loadOplataProfile(baseFormData, baseInitialValues) {
    const keyId = getKeyIdFromUrl();
    if (!keyId) {
      this.setState({
        formData: baseFormData,
        initialFormValues: baseInitialValues,
        paymentMode: 'public',
        keyId: '',
        paymentNotice: '',
        addReqVisibleNames: [],
        budgetVisibleNames: []
      });
      return;
    }

    const profileUrl = 'https://sbqr.ru/qr/get_qr_profile.php?key_id=' + encodeURIComponent(keyId);
    fetch(profileUrl)
      .then((res) => res.json())
      .then((profile) => {
        if (!profile.profile_found || profile.mode === 'public') {
          this.setState({
            formData: baseFormData,
            initialFormValues: baseInitialValues,
            paymentMode: 'public',
            keyId: keyId,
            paymentNotice: '',
            addReqVisibleNames: [],
            budgetVisibleNames: []
          });
          return;
        }

        const initialFormValues = { ...baseInitialValues };
        PAYEE_FIELD_NAMES.forEach((n) => {
          if (profile[n] != null) initialFormValues[n] = profile[n];
        });
        if (profile.CBC) initialFormValues.CBC = profile.CBC;
        if (profile.OKTMO) initialFormValues.OKTMO = profile.OKTMO;
        if (profile.mode !== 'expired' && profile.budget) initialFormValues.budget = true;

        if (profile.mode === 'expired') {
          this.setState({
            formData: baseFormData,
            initialFormValues,
            paymentMode: 'expired',
            keyId: keyId,
            paymentNotice: '',
            addReqVisibleNames: [],
            budgetVisibleNames: []
          });
          return;
        }

        const addReqFields = profile.add_req_fields || [];
        const addReqVisibleNames = addReqFields.filter((f) => f.visible).map((f) => f.name);
        const budgetVisibleNames = computeBudgetVisibleNames(profile, addReqFields);
        const mergedFormData = { ...baseFormData };
        addReqFields.filter((f) => f.visible).forEach((f, i) => {
          mergedFormData['add_' + i] = {
            NAME: f.name,
            DESCRIPTION: f.label,
            TYPE_FIELD: 'input',
            REQUIRED: '0',
            TOOLTIP: '',
            REG_EXP: '',
            MESSAGE: '',
            IS_ADD_REQ: '1'
          };
        });
        addReqFields.filter((f) => !f.visible).forEach((f) => {
          initialFormValues[f.name] = f.value || '';
        });

        this.setState({
          formData: mergedFormData,
          initialFormValues,
          paymentMode: 'paid',
          keyId: keyId,
          paymentNotice: '',
          addReqVisibleNames,
          budgetVisibleNames
        });
      })
      .catch(() => {
        this.setState({
          formData: baseFormData,
          initialFormValues: baseInitialValues,
          paymentMode: 'public',
          keyId: keyId,
          paymentNotice: '',
          addReqVisibleNames: [],
          budgetVisibleNames: []
        });
      });
  }

  shouldShowOplataField(fd, values) {
    if (Number(this.state.formId) !== OPLATA_FORM_ID) return true;
    const name = fd.NAME;
    const mode = this.state.paymentMode;

    if (mode === 'expired' && !BUDGET_FIELD_NAMES.includes(name)) {
      return EXPIRED_VISIBLE_FIELDS.includes(name);
    }

    if (mode === 'paid' && fd.IS_ADD_REQ !== '1' && this.state.addReqVisibleNames.includes(name)) {
      return false;
    }

    if (mode === 'paid' && this.state.addReqVisibleNames.length > 0) {
      if (PAYER_SUM_NAMES.includes(name) && name !== 'summaRub' && name !== 'summaKop' && fd.IS_ADD_REQ !== '1') {
        return false;
      }
    }

    if (BUDGET_FIELD_NAMES.includes(name)) {
      if (this.state.keyId && mode === 'paid') {
        if (name === 'budget') return false;
        if (fd.IS_ADD_REQ === '1') return true;
        return this.state.budgetVisibleNames.includes(name);
      }
      if (name === 'budget') return true;
      return !!values.budget;
    }

    return true;
  }

  isPayeeReadonly(fd) {
    return (
      Number(this.state.formId) === OPLATA_FORM_ID &&
      this.state.paymentMode === 'paid' &&
      PAYEE_FIELD_NAMES.includes(fd.NAME)
    );
  }

  isOplataFieldRequired(fd) {
    if (Number(this.state.formId) !== OPLATA_FORM_ID) {
      return fd.REQUIRED === '1';
    }
    const mode = this.state.paymentMode;
    const name = fd.NAME;
    if (name === 'summaKop') return false;
    if (mode === 'paid') {
      if (fd.IS_ADD_REQ === '1') return false;
      if (PAYEE_FIELD_NAMES.includes(name)) return false;
      if (PAYER_SUM_NAMES.includes(name)) return false;
      if (BUDGET_FIELD_NAMES.includes(name) && name !== 'budget') return false;
      return false;
    }
    if (mode === 'expired') {
      if (BUDGET_FIELD_NAMES.includes(name) && name !== 'budget') {
        return false;
      }
      return EXPIRED_VISIBLE_FIELDS.includes(name);
    }
    if (BUDGET_FIELD_NAMES.includes(name) && name !== 'budget') {
      return false;
    }
    return fd.REQUIRED === '1';
  }

  validateOplataField(fd, value, values) {
    let error;
    const name = fd.NAME;
    const strVal = value == null ? '' : String(value).trim();
    const required = this.isOplataFieldRequired(fd);

    if (Number(this.state.formId) === OPLATA_FORM_ID) {
      const mode = this.state.paymentMode;
      if (name === 'PayeeINN' && required && !/^[0-9]{10,12}$/.test(strVal)) {
        return 'Укажите ИНН (10 или 12 цифр)';
      }
      if (name === 'PersonalAcc' && required && !/^[0-9]{20}$/.test(strVal)) {
        return 'Укажите расчётный счёт (20 цифр)';
      }
      if (name === 'BIC' && required && !/^[0-9]{9}$/.test(strVal)) {
        return 'Укажите БИК (9 цифр)';
      }
      if (name === 'CorrespAcc' && required && !/^([0-9]{20}|0)$/.test(strVal)) {
        return 'Укажите К/С (20 цифр или 0)';
      }
      if (name === 'Name' && required && strVal === '') {
        return 'Укажите наименование получателя';
      }
      if (name === 'lastName' && required && strVal.length < 4) {
        return 'Заполните ФИО (не менее 4 символов)';
      }
      if (name === 'payerAddress' && required && strVal.length < 5) {
        return 'Заполните адрес (не менее 5 символов)';
      }
      if (name === 'Purpose' && required && strVal.length < 5) {
        return 'Заполните назначение (не менее 5 символов)';
      }
      if (name === 'summaRub' && required && strVal === '') {
        return 'Укажите сумму';
      }
      if (values.budget && name === 'CBC' && strVal === '') {
        return 'Укажите КБК';
      }
      if (values.budget && name === 'OKTMO' && strVal === '') {
        return 'Укажите ОКТМО';
      }
      if (mode === 'paid' && !required && strVal === '') {
        return undefined;
      }
    }

    if (required && strVal === '' && fd.TYPE_FIELD !== 'checkbox') {
      error = 'Заполните поле';
    }
    if (fd.REG_EXP && strVal && fd.TYPE_FIELD !== 'datetime_picker') {
      if (!eval(fd.REG_EXP).test(strVal)) {
        error = 'Заполните -' + fd.MESSAGE;
      }
    }
    return error;
  }

  renderOplataPromo() {
    if (Number(this.state.formId) !== OPLATA_FORM_ID) {
      return null;
    }
    const mode = this.state.paymentMode;
    if (mode === 'public') {
      return (
        <div className="form-promo">
          <p className="form-promo__lead">
            💡 Нужен личный кабинет для вашей организации?
          </p>
          <p className="form-promo__text">
            Создайте личный кабинет — реквизиты вашей организации будут подставляться автоматически,
            можно настроить поля для плательщика и готовить QR по спискам начислений. Пробный месяц бесплатно.
          </p>
          <a
            className="form-promo__btn btn-primary-cta"
            href={OPLATA_CABINET_SIGNUP_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Создать личный кабинет
          </a>
        </div>
      );
    }
    if (mode === 'expired' && this.state.keyId) {
      const renewUrl = OPLATA_CABINET_RENEW_BASE + encodeURIComponent(this.state.keyId);
      return (
        <div className="form-promo form-promo--expired">
          <p className="form-promo__lead form-promo__lead--warning">
            💡 Срок подписки истёк — заполните все поля вручную или продлите доступ к личному кабинету.
          </p>
          <p className="form-promo__text">
            Продление вернёт автоподстановку реквизитов получателя, настройку дополнительных полей
            и доступ к групповой подготовке квитанций с QR-кодом.
          </p>
          <a
            className="form-promo__btn btn-primary-cta"
            href={renewUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            Продлить личный кабинет
          </a>
        </div>
      );
    }
    return null;
  }
  
handleChangeQR(event){
	 const {name, value} = event.target
	 this.setState({ [name]: value});      
	
}

updateChangeQR = (value) => {
	 this.setState({ QRstyle: value});      	
}


updateDataPosColor = (color) => {   
  this.setState({ posColorQR: color });  
}

updateDataOtherColor = (color) => {   
  this.setState({ otherColorQR: color });  
}

updateDataBgColor = (color) => {   
  this.setState({ bgColorQR: color });  
}

updateDataEyeColor = (color) => {   
  this.setState({ eyeColorQR: color });  
}

updateDataGradientColor1 = (color) => {   
  this.setState({ gradientColor1: color });  
}

updateDataGradientColor2 = (color) => {   
  this.setState({ gradientColor2: color });  
}

 onDrop(picture) {
	    console.log('Загрузка изображения ' + picture[0].name );
		
		let file = picture[0];
		//console.log('Путь изображения ' + URL.createObjectURL(picture[0]) );
		let reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onloadend = () => {
		  this.setState({			
			icon: reader.result,
			imgQR: URL.createObjectURL(file)			
			});        
			}
		
 }
 
  render() {
    const formData = this.state.formData;
	const title = this.state.title;
    const intro = this.state.intro;	
	const body = this.state.body;
	const finality = this.state.finality;
	const formName = this.state.formName;
	
	const visualParametrs = {  
	'QRNormal': ['sizeQR','typeQR','posTypeQR','opacityQR','imgQR','otherColorQR','posColorQR'],
    'QRResImage': ['imgQR','otherColorQR','posColorQR'],	
	'QRBubble': ['posColorQR'],
	'QRDsj': ['posTypeQR2','scaleQR','crossWidthQR','posWidhQR'],
	'QRLine': [],
	'QRRandRect': [],
	'QRCustom': ['sizeCustomQR','imgQR','otherColorQR','bgColorQR','eyeColorQR','logoSizeQR','qrStyleCustom','eyeRadiusQR','logoPaddingQR','gradientType','gradientColor1','gradientColor2']
	}
  

	
    return (
      <div className="app-layout app-layout--with-sidebar">
        <SEO
          title={title}
          description={intro}
          thumbnail="https://sbqr.ru/favicon.ico"
          url={"https://sbqr.ru/qr/create/" + formName}
        />

        <Navbar className="app-header" bg="dark" variant="dark" expand="lg">
          <Navbar.Brand href="/">На главную</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              <Nav.Link href="/page/QRcode_dlya_oplaty.html">Создать QR для оплаты</Nav.Link>
              <Nav.Link href="/#portfolio">Услуги</Nav.Link>
              <Nav.Link href="/#about">Преимущества</Nav.Link>
              <Nav.Link href="/wp/">Инструкции</Nav.Link>
              <Nav.Link href="/#reviews">Отзывы</Nav.Link>
              <Nav.Link href="/#choice">Контакты</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        <LeftSidebar />

        <main className="app-main">
          <header className="app-hero">
            <h1>{title}</h1>
            <div className="app-intro" dangerouslySetInnerHTML={{ __html: intro }} />
            <h2>Для получения QR кода заполните форму</h2>
            <p className="lead">
              Это бесплатно. Можно скачать в удобном для Вас формате изображения (jpeg, png) или версии
              для печати в pdf.
            </p>
          </header>

          <div className="form-card"> 
	<Formik 
		  enableReinitialize
		  initialValues={this.state.initialFormValues}
		onSubmit={values => {
			
			let qrText = "";
			
			if (values)
			{   
				// Build payload for server without mutating form values (keep datetime_picker as "YYYY-MM-DDTHH:mm")
				const payload = { ...values, formId: this.state.formId };
				if (Number(this.state.formId) === OPLATA_FORM_ID && this.state.keyId) {
					payload.key_id = this.state.keyId;
				}
				Object.values(this.state.formData).forEach((fd) => {
					if (fd.TYPE_FIELD === "datetime_picker" && payload[fd.NAME] != null) {
						payload[fd.NAME] = formatDateTimeForServer(payload[fd.NAME]);
					}
				});
				console.log(payload);
				this.setState( (state) => {return { isFill: true} } );
				this.setState( (state) => {return { isVisiableQR: false} });
				
				
			// Request in back
			  
			    fetch("https://sbqr.ru/qr/get_qr_text.php", {
				   method: "POST",				   		   
				   body:  JSON.stringify(payload)
				})
				.then(res => res.json())
				.then(result => {
					console.log("3. result=" + Object.values(result));
					qrText = Object.values(result)[0];
					this.setState({ rezData: result,
					                valueQR: qrText,
					                isVisiableQR: true});                    					
					});
				if (!this.state.isVisiableQR) {
				   Object.values(this.state.rezData).map( (item,key) => qrText = qrText + item );
                   console.log("qrText=" + qrText);				   
				}
				
				console.log("valueQR=" + this.state.valueQR);				
				
			}
		  }}
		>
		{({ errors, touched, isValidating, values }) => ( 
				  <Form>
				  {this.renderOplataPromo()}
				  {this.state.paymentNotice ? (
				    <div className="form-field__notice">{this.state.paymentNotice}</div>
				  ) : null}
				  {
					  (Number(this.state.formId) === OPLATA_FORM_ID
					    ? sortOplataFormFieldKeys(formData)
					    : Object.keys(formData)
					  ).map((ind) => {
						const fd = formData[ind];
						if (!this.shouldShowOplataField(fd, values)) {
						  return null;
						}
						const required = this.isOplataFieldRequired(fd);
						const readOnly = this.isPayeeReadonly(fd);
						const prefilledInputClass = readOnly ? 'form-field__input--prefilled' : undefined;
						const validate = (value) => {
							this.setState( (state) => {return { isVisiableQR: false} });
							return this.validateOplataField(fd, value, values);
						};
						return (
					  <div key={ind} className={'form-field' + (readOnly ? ' form-field--prefilled' : '')}>
						  
						  <label>{fd.DESCRIPTION}</label>:<br />
						  { (() => {
								switch (fd.TYPE_FIELD) {
									case "select":
										return (
											<Field as="select" name={fd.NAME} id={fd.NAME} className={prefilledInputClass} required={required} validate={validate} readOnly={readOnly}>
												<option value="">Выберите из списка</option>
												{fd.TOOLTIP.split("|").map( (item) => <option key={item} value={item}>{item}</option> )}
											</Field>
										);
									case "datetime_picker":
										return (
											<Field name={fd.NAME} id={fd.NAME} className={prefilledInputClass} component={DateTimePicker} required={required} placeholder={fd.TOOLTIP} validate={validate} readOnly={readOnly} />
										);
									case "yandex_map":
										return (
											<Field
												name={fd.NAME}
												id={fd.NAME}
												component={YandexMapPicker}
												placeholder={fd.TOOLTIP}
												required={required}
												validate={validate}
											/>
										);
									case "checkbox":
										return (
											<Field type="checkbox" name={fd.NAME} id={fd.NAME} validate={validate} />
										);
									case "readonly":
										return (
											<Field name={fd.NAME} id={fd.NAME} className="form-field__input--prefilled" readOnly={true} validate={validate} />
										);
									default:
										return (
											<Field name={fd.NAME} id={fd.NAME} className={prefilledInputClass} placeholder={fd.TOOLTIP} required={required} validate={validate} readOnly={readOnly} />
										);
								}
						  })() }
						  {eval(`errors.${fd.NAME}`) && eval(`touched.${fd.NAME}`) && <div className="form-field__error">{eval(`errors.${fd.NAME}`)}</div>} 
						  
						  
					 </div>
						);
					  })
					}
				    
					{!this.state.isFill && <div className="form-field__error">Заполните необходимые поля и нажмите на кнопку!</div>}
					<div className="form-card__actions">	
					  <button type="submit">Создать QR</button>
					</div>

                  
					
				  </Form>
  )}
		</Formik>
		</div>
		
		
		    <QRdiv      	
			  idQR = {this.state.idQR}
			  formId = {this.state.formId}
			  valueQR = {this.state.valueQR}
			  sizeQR = {this.state.sizeQR}
			  sizeCustomQR = {this.state.sizeCustomQR}
			  levelQR = {this.state.levelQR}			  
			  typeQR = {this.state.typeQR}
			  posTypeQR = {this.state.posTypeQR}
			  posTypeQR2 = {this.state.posTypeQR2}
			  opacityQR = {this.state.opacityQR}
			  otherColorQR = {this.state.otherColorQR}
			  posColorQR = {this.state.posColorQR}
			  isMarginQR = {this.state.isMarginQR}
			  scaleQR = {this.state.scaleQR}
			  crossWidthQR = {this.state.crossWidthQR}
			  posWidhQR = {this.state.posWidhQR}
			  isVisiableQR = {this.state.isVisiableQR}	  			  
			  QRstyle = {this.state.QRstyle}
			  icon = {this.state.icon}
			  imgQR = {this.state.imgQR}
			  bgColorQR = {this.state.bgColorQR}
			  eyeColorQR = {this.state.eyeColorQR}
			  logoSizeQR = {this.state.logoSizeQR}
			  qrStyleCustom = {this.state.qrStyleCustom}
			  eyeRadiusQR = {this.state.eyeRadiusQR}
			  logoPaddingQR = {this.state.logoPaddingQR}
			  gradientType = {this.state.gradientType}
			  gradientColor1 = {this.state.gradientColor1}
			  gradientColor2 = {this.state.gradientColor2}
			/>
			
      
	  <ChangeStyleQR updateData={this.updateChangeQR} />
	  
	  <div className="settings-grid__row settings-grid__row--triple">
		   <div className="settings-grid__field settings-grid__field--split">
			  <label className="settings-grid__label" htmlFor="levelQR">Качество детализации</label>
			  <div className="settings-grid__control">
				  <select id="levelQR" name="levelQR" value={this.state.levelQR} onChange={this.handleChangeQR.bind(this)}>
					<option value="H">30%</option>            
					<option value="Q">25%</option>				
					<option value="M">15%</option>
					<option value="L">7%</option>				
				  </select>
			  </div>
			</div>
			{  ( visualParametrs[this.state.QRstyle].indexOf("sizeQR") !== -1 ) ? (
			  <div className="settings-grid__field settings-grid__field--split">
				  <label className="settings-grid__label" htmlFor="sizeQR">Размер</label>
				  <div className="settings-grid__control"><input id="sizeQR" type="text" name="sizeQR" value={this.state.sizeQR} onChange={this.handleChangeQR.bind(this)} /> </div>
			  </div>
			) : null  }
						{  ( visualParametrs[this.state.QRstyle].indexOf("sizeCustomQR") !== -1 ) ? (
			  <div className="settings-grid__field settings-grid__field--split">
				  <label className="settings-grid__label" htmlFor="sizeCustomQR">Размер</label>
				  <div className="settings-grid__control"><input id="sizeCustomQR" type="text" name="sizeCustomQR" value={this.state.sizeCustomQR} onChange={this.handleChangeQR.bind(this)} /> </div>
			  </div>
			) : null  }
	  </div>
	  <div className="settings-grid__row">
	  {  ( visualParametrs[this.state.QRstyle].indexOf("typeQR") !== -1 ) ? (
			<div className="settings-grid__field settings-grid__field--split">
			  <label className="settings-grid__label" htmlFor="typeQR">Стиль точки</label>
			  <div className="settings-grid__control">
				  <select id="typeQR" name="typeQR" value={this.state.typeQR} onChange={this.handleChangeQR.bind(this)}>
					<option value="rect">Прямоугольник</option>            
					<option value="round">Круг</option>				
					<option value="rand">Случайный</option>				
				  </select>
			  </div>
		   </div>
	  ) : null	  }
	  {  ( visualParametrs[this.state.QRstyle].indexOf("posTypeQR") !== -1 ) ? (
		   <div className="settings-grid__field settings-grid__field--split">
			  <label className="settings-grid__label" htmlFor="posTypeQR">Якорный стиль</label>
			  <div className="settings-grid__control">
				  <select id="posTypeQR" name="posTypeQR" value={this.state.posTypeQR} onChange={this.handleChangeQR.bind(this)}>
					<option value="rect">Прямоугольник</option>            
					<option value="round">Круг</option>				
					<option value="planet">Планета</option>				
					<option value="roundRect">Овал</option>				
				  </select>
			  </div>
		  </div>
		  ) : null
	  }
	</div>
	  <div className="settings-grid__row">
	  {  ( visualParametrs[this.state.QRstyle].indexOf("opacityQR") !== -1 ) ? (
		  <div className="settings-grid__field settings-grid__field--split">
			  <label className="settings-grid__label" htmlFor="opacityQR">Непрозрачность</label>
			  <div className="settings-grid__control"><input id="opacityQR" type="text" name="opacityQR" value={this.state.opacityQR} onChange={this.handleChangeQR.bind(this)} /> </div>
		  </div>
		  ) : null
	  }		  
	  {  ( visualParametrs[this.state.QRstyle].indexOf("scaleQR") !== -1 ) ? (
		  <div className="settings-grid__field settings-grid__field--split">
			  <label className="settings-grid__label" htmlFor="scaleQR_first">Масштаб</label>
			  <div className="settings-grid__control"><input id="scaleQR_first" type="text" name="scaleQR" value={this.state.scaleQR} onChange={this.handleChangeQR.bind(this)} /> </div>
		  </div>
		) : null  }				  
	  </div>

	  
	  <div className="settings-grid__row" >
	  {  ( visualParametrs[this.state.QRstyle].indexOf("otherColorQR") !== -1 ) ? (
			<div className="settings-grid__field settings-grid__field--split">
			  <span className="settings-grid__label">Цвет точки</span>
			  <div className="settings-grid__control">
				<SketchColor updateData={this.updateDataOtherColor}  />
			  </div>   
		    </div>
	  ) : null  }				  	
	  {  ( visualParametrs[this.state.QRstyle].indexOf("posColorQR") !== -1 ) ? (
			<div className="settings-grid__field settings-grid__field--split">
			  <span className="settings-grid__label">Цвет 3-х привязок</span>
			  <div className="settings-grid__control">
				<SketchColor updateData={this.updateDataPosColor}  />
			  </div>		   
			</div>	  
      ) : null  }
	  {  ( visualParametrs[this.state.QRstyle].indexOf("bgColorQR") !== -1 ) ? (
			<div className="settings-grid__field settings-grid__field--split">
			  <span className="settings-grid__label">Цвет фона</span>
			  <div className="settings-grid__control">
				<SketchColor updateData={this.updateDataBgColor}  />
			  </div>		   
			</div>	  
      ) : null  }
	  {  ( visualParametrs[this.state.QRstyle].indexOf("eyeColorQR") !== -1 ) ? (
			<div className="settings-grid__field settings-grid__field--split">
			  <span className="settings-grid__label">Цвет маркеров</span>
			  <div className="settings-grid__control">
				<SketchColor updateData={this.updateDataEyeColor}  />
			  </div>		   
			</div>	  
      ) : null  }				  				
	  </div>
	  
	  <div className="settings-grid__row settings-grid__row--triple">
	  {  ( visualParametrs[this.state.QRstyle].indexOf("gradientType") !== -1 ) ? (
			<div className="settings-grid__field settings-grid__field--split">
			  <label className="settings-grid__label" htmlFor="gradientType">Тип градиента</label>
			  <div className="settings-grid__control">
				  <select id="gradientType" name="gradientType" value={this.state.gradientType} onChange={this.handleChangeQR.bind(this)}>
					<option value="none">Без градиента</option>
					<option value="linear">Линейный</option>
					<option value="radial">Радиальный</option>
				  </select>	
			  </div>		   
			</div>	  
      ) : null  }
	  {  ( visualParametrs[this.state.QRstyle].indexOf("gradientColor1") !== -1 && this.state.gradientType !== 'none' ) ? (
			<div className="settings-grid__field settings-grid__field--split">
			  <span className="settings-grid__label">Цвет градиента 1</span>
			  <div className="settings-grid__control">
				<SketchColor updateData={this.updateDataGradientColor1}  />
			  </div>		   
			</div>	  
      ) : null  }
	  {  ( visualParametrs[this.state.QRstyle].indexOf("gradientColor2") !== -1 && this.state.gradientType !== 'none' ) ? (
			<div className="settings-grid__field settings-grid__field--split">
			  <span className="settings-grid__label">Цвет градиента 2</span>
			  <div className="settings-grid__control">
				<SketchColor updateData={this.updateDataGradientColor2}  />
			  </div>		   
			</div>	  
      ) : null  }
	  </div>			
	  
	  <div className="settings-grid__row settings-grid__row--triple">
	  {  ( visualParametrs[this.state.QRstyle].indexOf("scaleQR") !== -1 ) ? (	  
		   <div className="settings-grid__field settings-grid__field--split">
			  <label className="settings-grid__label" htmlFor="crossWidthQR">Толщина вилки</label>
			  <div className="settings-grid__control"><input id="crossWidthQR" type="text" name="crossWidthQR" value={this.state.crossWidthQR} onChange={this.handleChangeQR.bind(this)} /> </div>
		  </div>
	  ) : null  }	
	  {  ( visualParametrs[this.state.QRstyle].indexOf("posWidhQR") !== -1 ) ? (	  	  
		  <div className="settings-grid__field settings-grid__field--split">
			  <label className="settings-grid__label" htmlFor="posWidhQR">Ширина 3-х привязки</label>
			  <div className="settings-grid__control"><input id="posWidhQR" type="text" name="posWidhQR" value={this.state.posWidhQR} onChange={this.handleChangeQR.bind(this)} /> </div>
		  </div>
	  ) : null  }
	  {  ( visualParametrs[this.state.QRstyle].indexOf("logoSizeQR") !== -1 ) ? (	  	  
		  <div className="settings-grid__field settings-grid__field--split">
			  <label className="settings-grid__label" htmlFor="logoSizeQR">Размер логотипа <p>Процент от размера QR (10–50%)</p></label>
			  <div className="settings-grid__control"><input id="logoSizeQR" type="number" min="10" max="50" step="1" name="logoSizeQR" value={this.state.logoSizeQR} onChange={this.handleChangeQR.bind(this)} /> </div>
		  </div>
	  ) : null  }
	  {  ( visualParametrs[this.state.QRstyle].indexOf("eyeRadiusQR") !== -1 ) ? (	  	  
		  <div className="settings-grid__field settings-grid__field--split">
			  <label className="settings-grid__label" htmlFor="eyeRadiusQR">Радиус маркеров <p>Закругление углов маркеров (0–20)</p></label>
			  <div className="settings-grid__control"><input id="eyeRadiusQR" type="number" min="0" max="20" step="1" name="eyeRadiusQR" value={this.state.eyeRadiusQR} onChange={this.handleChangeQR.bind(this)} /> </div>
		  </div>
	  ) : null  }
	  {  ( visualParametrs[this.state.QRstyle].indexOf("logoPaddingQR") !== -1 ) ? (	  	  
		  <div className="settings-grid__field settings-grid__field--split">
			  <label className="settings-grid__label" htmlFor="logoPaddingQR">Отступ логотипа <p>Пространство вокруг логотипа (0–20)</p></label>
			  <div className="settings-grid__control"><input id="logoPaddingQR" type="number" min="0" max="20" step="1" name="logoPaddingQR" value={this.state.logoPaddingQR} onChange={this.handleChangeQR.bind(this)} /> </div>
		  </div>
	  ) : null  }			  
      </div>		  
  	  <div className="settings-grid__row">
	  {  ( visualParametrs[this.state.QRstyle].indexOf("posTypeQR2") !== -1 ) ? (	  	  
		  <div className="settings-grid__field settings-grid__field--split">
			  <label className="settings-grid__label" htmlFor="posTypeQR2">Якорный стиль</label>
			  <div className="settings-grid__control">
				  <select id="posTypeQR2" name="posTypeQR2" value={this.state.posTypeQR2} onChange={this.handleChangeQR.bind(this)}>
					<option value="rect">Квадрат</option>            				
					<option value="dsj">Секторы</option>				
				  </select>
			  </div>
		  </div>
	   ) : null  }
	  {  ( visualParametrs[this.state.QRstyle].indexOf("qrStyleCustom") !== -1 ) ? (	  	  
		  <div className="settings-grid__field settings-grid__field--split">
			  <label className="settings-grid__label" htmlFor="qrStyleCustom">Стиль точек <p>Форма элементов QR кода</p></label>
			  <div className="settings-grid__control">
				  <select id="qrStyleCustom" name="qrStyleCustom" value={this.state.qrStyleCustom} onChange={this.handleChangeQR.bind(this)}>
					<option value="squares">Квадраты</option>
					<option value="dots">Точки (круглые)</option>
				  </select>	
			  </div>		   
		  </div>			
	  ) : null  }			  		  
	  </div>

	  {  ( visualParametrs[this.state.QRstyle].indexOf("imgQR") !== -1 ) ? (	  	  			  	  
	  <div className="settings-grid__row" >	
			  <div className="settings-grid__field settings-grid__field--split">
			  <span className="settings-grid__label">Изображение/логотип <p>Доступно .jpg, .gif, .png</p><p>Рекомендованное разрешение 100×100 пикселей</p></span>
			  <div className="settings-grid__control">
				  <ImageUploader
						className="upload-widget"
						withIcon={false}
						withLabel={false}
						buttonText='Загрузить'
						onChange={this.onDrop.bind(this)}
						imgExtension={['.jpg', '.gif', '.png']}
						maxFileSize={5242880}				
						label='Доступно .jpg, .gif, .png '
						fileSizeError='Файл слишком большой. Максимальный размер 5Мб'
						singleImage={true}
						buttonStyles={{
						  width: '100%',
						  maxWidth: 220,
						  padding: '10px 16px',
						  background: '#ffd136',
						  color: '#111111',
						  border: 'none',
						  borderRadius: 8,
						  fontWeight: 600,
						  cursor: 'pointer',
						  transition: 'all 0.2s ease-in-out',
						}}
					/>		   
				</div>
			  </div>
	  </div>			
		) : null  }
	  
	  
	  <h2>Описание</h2>
	  <div className="body" dangerouslySetInnerHTML={{__html: body}}>
	  </div>
	  
	  <div className="body" dangerouslySetInnerHTML={{__html: finality}}>
	  </div>

        </main>
      </div>
    );
  }
}

// Wrapper component to use React Router v6 hooks with class component
function App() {
  const { formName } = useParams();
  return <AppComponent formName={formName} />;
}

export default App;